import React from 'react';
import './PageHeader.scss';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backButton?: {
    label: string;
    onClick: () => void;
  };
  actions?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  backButton,
  actions,
}) => {
  return (
    <div className="page-header">
      <div className="page-header-left">
        {backButton && (
          <button className="page-header-back" onClick={backButton.onClick} type="button">
            ← {backButton.label}
          </button>
        )}
        <div className="page-header-title-group">
          <h1 className="page-header-title">{title}</h1>
          {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
};

